import {DeliveryPoint} from "@app/core/delivery-point/application/dtos/delivery-point";
import {Credentials} from "@app/core/credentials/domain/credentials";
import {GetDeliveryPointsUseCase} from "@app/core/delivery-point/application/get-delivery-points.use-case";
import {Injectable} from "@angular/core";
import {take} from "rxjs/operators";
import {firstValueFrom} from 'rxjs';

export type DeliveryPointSelector = (deliveryPoints: DeliveryPoint[]) => Promise<DeliveryPoint | null>

export interface SelectDeliveryPointUseCaseParams {
    credentials?: Credentials;
    deliveryPointSelector: DeliveryPointSelector;
}

/**
 * Use case for handling the user's delivery point selection.
 */
@Injectable({
    providedIn: 'root'
})
export class SelectDeliveryPointUseCase {

    constructor(
        private getDeliveryPointsUseCase: GetDeliveryPointsUseCase
    ) { }

    async execute(params: SelectDeliveryPointUseCaseParams): Promise<DeliveryPoint | null> {
        const deliveryPoints = await firstValueFrom(this.getDeliveryPointsUseCase.execute(params.credentials).pipe(take(1)));
        return this.selectDeliveryPoint(deliveryPoints, params.deliveryPointSelector);
    }

    private async selectDeliveryPoint(deliveryPoints: DeliveryPoint[], deliveryPointSelector: DeliveryPointSelector): Promise<DeliveryPoint | null> {
        const availableDeliveryPoints =  deliveryPoints.filter(deliveryPoint => !deliveryPoint.blocked);
        if (availableDeliveryPoints.length == 1) {
            return availableDeliveryPoints[0];
        }
        return deliveryPointSelector(deliveryPoints);
    }
}

